import axios from 'axios';
import router from '@/router'

axios.defaults.timeout = 5000; //请求超时5秒
axios.defaults.orURL = process.env.NODE_ENV == 'development' ? '/api' : 'https://web.justhouse.cn/BigInterface';
// axios.defaults.orURL = process.env.NODE_ENV == 'development' ? 'https://web.justhouse.cn/BigInterface' : 'https://web.justhouse.cn/BigInterface';
axios.defaults.imgURL = process.env.NODE_ENV == 'development' ? '/img' : 'https://file.ltbhome.com/Upload';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; //设置
const _this = this;
axios.interceptors.request.use(
    config => {
        let token = sessionStorage.getItem('token')
        if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers = {
                'X-token': token
            }
        }

        return config
    },
    err => {
        return Promise.reject(err)
    }
)
axios.interceptors.response.use(
    response => {
        if (response.data.code === 4003) {
            Toast({
                mes: '您没有权限操作！',
                timeout: 1500,
                callback: () => {
                    router.go(-1);
                }
            });

            return false;
        }
        var that = this
        if (response.data.code === 3) {
            // localStorage.removeItem('token')
            router.push("/")


        }
        if (response.code === 3) {
            // localStorage.removeItem('token')
            router.push("/")

            //redirect: '/#'
        }
        return response
    },
    err => {
        if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
            Toast({
                mes: '网络异常，连接超时...',
                timeout: 1500
            });
        }
        return Promise.reject(err)
    }
)
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params})
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}


// WEBPACK FOOTER //
// ./src/request/http.js